module.exports = __webpack_public_path__ + "@/assets/img/1.1b52b6d1.jpg";